import styled from '@emotion/styled';

export const Root = styled.li`
  display: flex;
  flex-direction: column;
  align-items: flex-start !important;
`;

export const Label = styled.div`
  font-family: Inter, sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
`;

export const Details = styled.div`
  font-family: Inter, sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
`;
